import React from 'react';

const divider = { divider: true, name: "divider-1" };

export function importExportActions(list, actionContext={ }){
	let displayableActions = list.filter((item) => {
		return item.shouldDisplay(actionContext);
	});

	let newList = displayableActions.map((action)=>{
		return{
			name: action.name,
			renderChild: ()=> <action.component {...actionContext} />,
		};
	});

	if(newList.some(act=>/import/gi.test(act.name)) && newList.some(act=>/export/gi.test(act.name))){
		let idx = newList.indexOf("Export");
		newList.splice(idx, 0, divider);
		return newList;
	}
	return newList;
}
